import actionCreatorFactory from 'typescript-fsa';
import * as types from './types';

const actionCreator = actionCreatorFactory('analysisOverview');

export const clearAnalysisData = actionCreator.async<void, void>(types.CLEAR_ANALYSIS_DATA);